import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import './ContactInformationSection.scss';
import { Text } from '@fluentui/react-components';
import { CommonLabelAndValueList } from '../../shared-components';
import { FlexBox } from '../../shared-components/flex-box';

const ContactInformationSectionImpl: React.FC = () => {
  const {
    reviewQuestionnairePageUiStore,
  } = useStores();

  return (
    <section
      className='review-questionnaire-page__section review-questionnaire-page__section--contact'
    >
      <Text
        block
        weight='semibold'
        size={400}
        as='h3'
      >
        Contact Information
      </Text>
      <FlexBox direction='column'>
        <Text italic>Public relations information:</Text>
        <CommonLabelAndValueList
          labelId='contactName'
          label='Contact name:'
          childrenFallback={reviewQuestionnairePageUiStore.questionnaire?.contact.contactName}
        />
        <CommonLabelAndValueList
          labelId='companyName'
          label='Company name:'
          childrenFallback={reviewQuestionnairePageUiStore.questionnaire?.contact.companyName}
        />
        <CommonLabelAndValueList
          labelId='companyWebsite'
          label='Company website:'
          childrenFallback={reviewQuestionnairePageUiStore.questionnaire?.contact.companyWebsite}
        />
      </FlexBox>
    </section>
  );
}

export const ContactInformationSection = observer(ContactInformationSectionImpl);
